import ShopCard, { ShopCardProps } from './ShopCard';

export type { ShopCardProps };

export default ShopCard;
